import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  InputGroup,
  Label,
  ModalHeader,
  FormGroup
} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CustomSelect from "../../../../components/Common/CustomSelect";

const OfferMediaBuyerBudgetModal = props => {

  const [rangeDate, setRangeDate] = React.useState({
    date: "01-09-2021 to 29-09-2021"
  });

  let state = {
    isFormSubmit: false
  };

  const getMediaBuyers = item => {
    let media = [];
    item.mediaBuyers.map(i => {
      media.push({ label: i.number, value: i.id });
    });
    return media;
  };

  const onSubmitForm = (e, errors, params) => {
    state = { isFormSubmit: true };
    if (errors?.length === 0) {
      let data = {
        offer: props.offer.id,
        mediaBuyer: params.mediaBuyer.value,
        budget: params.budget,
        date: rangeDate.date
      };
      props.addMediaBuyerBudget(data, props.currentMedia);
      return props.toggle();
    }
  };

  return (
    <Modal isOpen={props.isOpen} autoFocus={true} centered={true} toggle={props.toggle}>
      <ModalHeader tag="h4">Edit media buyer</ModalHeader>
      {props.data !== null && (
        <ModalBody>
          <AvForm className="needs-validation" onSubmit={onSubmitForm}>
            <Row form>
              <Col className="col-12">
                <div className="mb-3">
                  <Label htmlFor="offer">Media buyer</Label>
                  <FormGroup>
                    <CustomSelect
                      name="mediaBuyer"
                      options={getMediaBuyers(props.data)}
                      placeholder="Select media buyer..."
                      classNamePrefix="select2-selection"
                      errorMessage="Media buyer field is required"
                      required
                      isFormSubmit={state.isFormSubmit}
                    />
                  </FormGroup>
                </div>
                <div className="mb-3">
                  <AvField
                    name="budget"
                    label="Budget"
                    type="number"
                    errorMessage="Invalid budget"
                    validate={{
                      required: { value: true },
                      minLength: { value: 1, errorMessage: "Min 1 number" }
                    }}
                  />
                </div>
                <div className="mb-3">
                  <Label>Date Range</Label>
                  <InputGroup>
                    <Flatpickr
                      name="date"
                      className="form-control d-block"
                      placeholder="dd M,yyyy"
                      value={rangeDate.date}
                      style={{ backgroundColor: "white" }}
                      options={{
                        mode: "range",
                        dateFormat: "d-m-Y"
                      }}
                      onChange={(date, dateStr) =>
                        setRangeDate({ date: dateStr })
                      }
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button type="submit" className="btn btn-success save-user">
                    Save changes
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      )}
    </Modal>
  );
};

OfferMediaBuyerBudgetModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  addMediaBuyerBudget: PropTypes.func.isRequired,
  currentMedia: PropTypes.object.isRequired,
  offer: PropTypes.any
};

export default OfferMediaBuyerBudgetModal;
